import {
  App,
  Button,
  Descriptions,
  Dropdown,
  Modal,
  Popconfirm,
  Popover,
  Space,
  Tag,
} from 'antd';
import React, { useState } from 'react';
import {
  MdDelete,
  MdModeEditOutline,
  MdOutlinePayment,
  MdVisibility,
} from 'react-icons/md';
import { useSelector } from 'react-redux';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  AddbulkAction,
  deleteSalesInvoice,
  downloadZatca,
  downloadZatcaXml,
  getCreditNotes,
  getSalesInvoices,
  getZatcaDetails,
  submitSalesInvoice,
  submitToZatca,
} from '../../network/salesInvoice';
import { queryKeys } from '../../services/react-query/queryKeys';
import { useNavigate } from 'react-router-dom';
import { FaFileInvoiceDollar, FaMoneyBillWave } from 'react-icons/fa';
import {
  ModalAppPayment,
  ModalAppPdfData,
  ModalTodoList,
} from '../../components/upeosoft/ModalApp/ModalApp';
import DetailsInvoiceNumber from '../../components/common/DetailsInvoiceNumber/DetailsInvoiceNumber';
import StatusTag from '../../hooks/StatusHook';
import { GiFiles } from 'react-icons/gi';
import { SiKnowledgebase } from 'react-icons/si';
import { submitMaterialRequest } from '../../network/materialRequest';
import { TbDotsVertical } from 'react-icons/tb';
import {
  CheckOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  DollarOutlined,
  DownloadOutlined,
  DownOutlined,
  EditOutlined,
  FileTextOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import DashboardCards from '../Dashboard/DashboardCards';
import UseDownloadPdf from '../../hooks/DownloadPdf';
const CreditNotes = ({ t }) => {
  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [pageCount, setPageCount] = useState(1);
  const [total, setTotal] = useState(0);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [editIdDrawer, setEditIdDrawer] = useState(null);
  const [nameInvoiceZatca, setNameInvoiceZatca] = useState('');
  const [openPdfZatca, setOpenPdfZatca] = useState(false);
  const { onGetPDF, pdfData, setLoadingPdf, loadingPdf } = UseDownloadPdf();
  const [submitToZatcaLoading, setSubmitToZatcaLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [nameInvoice, setNameInvoice] = useState('');
  const [zatcaData, setZatcaData] = useState(null);
  const [openTask, setOpenTask] = useState(false);
  const [openPdf, setOpenPdf] = useState(false);
  const [idTask, setIdTask] = useState(null);
  const client = useQueryClient();
  const { currentLang } = useSelector((state) => state.user);
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getCreditNotes, currentLang],
    queryFn: () => getCreditNotes(currentLang),
    keepPreviousData: true,
  });
  const { mutate: onSubmitToZatca } = useMutation({
    mutationKey: ['submitToZatca'],
    mutationFn: (name) => submitToZatca(name),
    onSuccess: (data) => {
      //  console.log(data, 'data');
      setSubmitToZatcaLoading(false);
      console.log(data?.message, 'data');
      //  console.log(data?.message?.status, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      // data?.message?.message && message.success(data?.message?.message);
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesInvoices],
      });
    },
    onError: (error) => {
      setSubmitToZatcaLoading(false);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { mutate: onDownloadZatca, data: pdfDataZatca } = useMutation({
    mutationKey: ['downloadZatca'],
    mutationFn: ({ type, name, lang, format }) =>
      downloadZatca({ type, name, lang, format }),
    onSuccess: (data) => {
      console.log(data, 'data onDownloadZatca');
      console.log(data?.message, 'data');
      setLoadingPdf(false);
      //  console.log(data?.message?.status, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      // message.success('Download successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesInvoices],
      });
    },
    onError: (error) => {
      setLoadingPdf(false);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { mutate: onGetZatcaDetails } = useMutation({
    mutationKey: ['getZatcaDetails'],
    mutationFn: (name) => getZatcaDetails(name),
    onSuccess: (data) => {
      const msg = data?.message?.[0];
      let validationResults = [];
      if (msg?.status === 500) {
        message.error(msg?.message);
        return;
      }

      // setZatcaData({
      //   status: msg?.status,
      //   zatca_status: msg?.zatca_status,
      //   validationResults: JSON.parse(msg?.zatca_message),
      // });
      const parsedMessage = JSON.parse(msg.zatca_message);
      const results = parsedMessage?.validationResults ?? {};

      const allMessages = [
        ...(Array.isArray(results.infoMessages) ? results.infoMessages : []),
        ...(Array.isArray(results.warningMessages)
          ? results.warningMessages
          : []),
        ...(Array.isArray(results.errorMessages) ? results.errorMessages : []),
      ];

      validationResults = allMessages.map((item) => ({
        type: item.type,
        message: item.message,
      }));
      setZatcaData({
        status: msg?.status,
        zatca_status: msg?.zatca_status,
        validationResults,
      });
      setModalOpen(true);
    },
    onError: (error) => {
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { mutate: onDownloadZatcaXml } = useMutation({
    mutationKey: ['downloadZatcaXml'],
    mutationFn: (name) => downloadZatcaXml(name),
    // onSuccess: (response, name) => {
    //   const blob = new Blob([response.data], { type: 'application/xml' });
    //   const url = URL.createObjectURL(blob);
    //   const link = document.createElement('a');
    //   link.href = url;
    //   link.download = `invoice-${name}.xml`;
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    //   URL.revokeObjectURL(url);

    //   message.success('Download successfully');
    //   client.invalidateQueries({
    //     queryKey: [queryKeys.getSalesInvoices],
    //   });
    // },
    // onSuccess: (response, name) => {
    //   console.log('XML Content:', response.data.slice(0, 100));

    //   const blob = new Blob([response.data], { type: 'application/xml' });
    //   const url = URL.createObjectURL(blob);
    //   const link = document.createElement('a');
    //   link.href = url;
    //   link.download = `invoice-${name}.xml`;
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    //   URL.revokeObjectURL(url);

    //   message.success('Download successfully');
    //   client.invalidateQueries({
    //     queryKey: [queryKeys.getSalesInvoices],
    //   });
    // },
    onSuccess: (response, name) => {
      const xmlContent = response.data;

      console.log('First 100 XML Chars:', xmlContent.slice(0, 100));

      const blob = new Blob([xmlContent], {
        type: 'application/xml;charset=utf-8',
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `invoice-${name}.xml`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      message.success('Download successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesInvoices],
      });
    },
    onError: (error) => {
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });

  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteSalesInvoice(id),
      onSuccess: (data) => {
        // console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message);
        // message.success('تم الحذف بنجاح');
        client.invalidateQueries({
          queryKey: [queryKeys.getCreditNotes, currentLang],
        });
      },
      onError: () => {
        message.error('حدث خطأ ما');
      },
    }
  );

  const { mutate: onSubmitSalesInvoice } = useMutation({
    mutationKey: ['submitSalesInvoice'],
    mutationFn: (name) => submitMaterialRequest('Sales Invoice', name),
    onSuccess: (data) => {
      //  console.log(data, 'data');
      console.log(data?.message, 'data');
      //  console.log(data?.message?.status, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      data?.message?.message && message.success(data?.message?.message);
      client.invalidateQueries({
        queryKey: [queryKeys.getCreditNotes, currentLang],
      });
    },
    onError: (error) => {
      message.error(error);
    },
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit,
      icon: <MdModeEditOutline />,
      onClick: () => navigate(`/sales-invoice-credit/${record?.name}`),
    },
    {
      key: '2',
      label: t.GeneralLedger,

      icon: <GiFiles />,
      onClick: () =>
        navigate(`/general-ledger-report-credit-note/${record?.name}`),
    },
    {
      type: 'divider',
    },
    {
      key: '2-1',
      label: t.Payment,
      icon: <MdOutlinePayment />,
      disabled: record.status === 'Paid' ? true : false,
      onClick: () => {
        setOpen(true);
        setEditId(record?.name);
        setTotal(record?.outstanding_amount);
      },
    },
    {
      key: '5',
      label: t.paymentEntry,
      icon: <FileTextOutlined />,
      disabled:
        record.status === 'Draft'
          ? true
          : record.status === 'Cancelled'
          ? true
          : false,
      onClick: () => navigate(`/payment-entry/sales/${record?.name}`),
    },
    // {
    //   key: '6',
    //   label: t.Payment,
    //   icon: <FileTextOutlined />,
    //   disabled: record.status === 'Unpaid' ? false : true,
    //   onClick: () => {
    //     setOpen(true);
    //     setEditId(record?.name);
    //     setTotal(record?.base_grand_total);
    //   },
    // },
    {
      key: '7',
      label: t.submit,
      icon: <CheckOutlined />,
      disabled: record.status === 'Draft' ? false : true,
      onClick: () => onSubmitSalesInvoice(record.name),
    },
    {
      type: 'divider',
    },
    {
      key: '5-1',
      label: t.SubmitToZatca,
      // disabled: record.status === 'Draft' ? false : true,

      icon: <CheckOutlined />,
      onClick: () => {
        setSubmitToZatcaLoading(true);
        onSubmitToZatca(record?.name);
      },
    },
    {
      key: '6',
      label: t.getPDF,
      icon: <CheckOutlined />,
      onClick: () => {
        onGetPDF({
          type: 'Sales Invoice',
          name: record.name,
          lang: currentLang,
        });
        setNameInvoice(record.name);
        setOpenPdf(true);
      },
    },
    {
      key: '5-2',
      label: t.downloadZatcaPdf,
      // disabled: record.status === 'Draft' ? false : true,

      icon: <DownloadOutlined />,
      onClick: () => {
        onDownloadZatca({
          // type: 'Sales Invoice',
          name: record?.name,
          lang: currentLang,
          format: '',
        });
        setNameInvoiceZatca(record.name);
        setOpenPdfZatca(true);
      },
    },
    {
      key: '5-3',
      label: t.downloadZatcaXML,
      // disabled: record.status === 'Draft' ? false : true,

      icon: <DownloadOutlined />,
      onClick: () => onDownloadZatcaXml(record?.name),
    },
    {
      key: '5-4',
      label: t.GetZatcaDetails,
      // disabled: record.status === 'Draft' ? false : true,

      icon: <CheckOutlined />,
      onClick: () => onGetZatcaDetails(record?.name),
    },

    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.DeletetheSalesInvoice + ` (${record?.name})`}
          okText={t.yes}
          cancelText={t.no}
          onConfirm={() => handleRemove.mutate(record?.name)}
        >
          <span style={{ color: 'red' }}>{t.Delete}</span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: currentLang === 'en' ? 'Invoice Number' : 'رقم الفاتورة',
      dataIndex: 'name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record.name).toLowerCase();
        const searchValue = value.toLowerCase();
        // console.log(record);
        return name.includes(searchValue);
      },
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              navigate(`/sales-invoice-credit/${record.name}`);
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: currentLang === 'en' ? 'customer' : 'العميل',
      dataIndex: 'customer',
    },
    {
      title: currentLang === 'en' ? 'Date' : 'تاريخ',
      dataIndex: 'posting_date',
    },
    {
      title: currentLang === 'en' ? 'Total' : 'المجموع',
      dataIndex: 'base_grand_total',
    },
    {
      title: t.status,
      dataIndex: 'status',
      render: (status) => <StatusTag status={status} />,
    },
    {
      title: t.action,
      dataIndex: 'docstatus',
      key: 'docstatus',
      // width: 150,
      // align: 'center',
      render: (text, record) => {
        // console.log('record:', record);
        const enable_submit = record.status === 'Draft' ? true : false;
        const enable_payment_entry = record.status === 'Draft' ? true : false;
        return (
          <Dropdown
            menu={{ items: items(record) }}
            // placement="bottomRight"
            overlayClassName="custom-dropdown"
            trigger={['click']}
          >
            <Button
              type="text"
              icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
            />
          </Dropdown>
          // <Space>
          //   <Dropdown
          //     menu={{ items: items(record) }}
          //     trigger={['click']}
          //     // placement="bottomCenter"
          //   >
          //     <Button
          //       size="small"
          //       type="text"
          //       icon={<TbDotsVertical size={20} />}
          //     />
          //   </Dropdown>

          // </Space>
        );
      },
    },
  ];
  // const dataTable = data?.message?.sales_invoices?.map((item, index) => {
  //   return {
  //     key: index,
  //     ...item,
  //   };
  // });
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: item?.name,
      ...item,
    };
  });
  const { total_count, total_pages } = data?.message?.pagination || {};
  return (
    <div className="sales-invoice">
      {/* <Heading title={t.Finance} subTitle={t.salesInvoice} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading || submitToZatcaLoading}
          setSearchText={setSearchText}
          Placeholder={t.searchSalesInvoice}
          pathBtn="/sales-invoice/add"
          totalCount={total_count}
          totalPages={total_pages}
          setPageCount={setPageCount}
          pageCount={pageCount}
        />
      </div>
      <ModalAppPayment
        open={open}
        setOpen={setOpen}
        editId={editId}
        t={t}
        total={total}
      />
      <ModalAppPdfData
        open={openPdf}
        pdfData={pdfData}
        setOpen={setOpenPdf}
        nameInvoice={nameInvoice}
        t={t}
        onGetPDF={onGetPDF}
        type="Sales Invoice"
        setLoadingPdf={setLoadingPdf}
        loadingPdf={loadingPdf}
      />
      <ModalAppPdfData
        open={openPdfZatca}
        pdfData={pdfDataZatca}
        setOpen={setOpenPdfZatca}
        nameInvoice={nameInvoiceZatca}
        t={t}
        onGetPDF={onDownloadZatca}
        type="Sales Invoice"
        setLoadingPdf={setLoadingPdf}
        loadingPdf={loadingPdf}
      />

      <DetailsInvoiceNumber
        open={openDrawer}
        setOpen={setOpenDrawer}
        editId={editIdDrawer}
        t={t}
      />
      <ModalTodoList
        open={openTask}
        setOpen={setOpenTask}
        editId={idTask}
        doctype="Sales Invoice"
        t={t}
      />
      <Modal
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        footer={null}
        centered
        // title="تفاصيل ZATCA"
        title={t.zatcaDetails}
        width={800}
      >
        {zatcaData && (
          <Descriptions column={1} bordered>
            <Descriptions.Item label={t.status}>
              {/* {zatcaData.status} */}
              <StatusTag status={zatcaData.status} />
            </Descriptions.Item>
            {/* <Descriptions.Item label="حالة ZATCA"> */}
            <Descriptions.Item label={t.zatcaStatus}>
              {zatcaData.zatca_status}
            </Descriptions.Item>
            {/* {zatcaData.validationResults?.map((item, index) => (
                    <Descriptions.Item
                      label={`${t.message} ${index + 1}`}
                      key={index}
                    >
                      <span
                        style={{
                          color:
                            item.type === 'ERROR'
                              ? 'red'
                              : item.type === 'WARNING'
                              ? 'orange'
                              : 'green',
                        }}
                      >
                        {item.message}
                      </span>
                    </Descriptions.Item>
                  ))} */}

            {/* {Array.isArray(zatcaData?.validationResults) &&
                    zatcaData.validationResults.map((item, index) => (
                      <Descriptions.Item
                        label={`${t.message} ${index + 1}`}
                        key={index}
                      >
                        <span
                          style={{
                            color:
                              item.type === 'ERROR'
                                ? 'red'
                                : item.type === 'WARNING'
                                ? 'orange'
                                : 'green',
                          }}
                        >
                          {item.message}
                        </span>
                      </Descriptions.Item>
                    ))} */}
            <Descriptions.Item label={`${t.message}`}>
              {Array.isArray(zatcaData?.validationResults) &&
                zatcaData.validationResults.map((item, index) => (
                  <span key={index}>{item.message}</span>
                ))}
            </Descriptions.Item>

            {/* {zatcaData.validationResults?.infoMessages?.map((item, index) => (
                    <Descriptions.Item
                      label={`${t.message} ${index + 1}`}
                      key={index}
                    >
                      {item.message}
                    </Descriptions.Item>
                  ))} */}
          </Descriptions>
        )}
      </Modal>
    </div>
  );
};

export default CreditNotes;
